import { Directive, ElementRef, HostListener } from '@angular/core';
import { getCleanStringNumber, getCurrencyValue } from '../functions/currency.functions';

@Directive({
  selector: '[appCurrencyValidator]'
})
export class CurrencyValidatorDirective {
  private nativeElement: HTMLInputElement;
  private readonly ONLY_NUMBERS: RegExp = new RegExp(/^[$\d]*$/g);
  public output: string;

  constructor(
    //@Host() @Self() @Optional() hostInput: ElementRef<HTMLInputElement>,
    hostInput: ElementRef
  ) {
    this.nativeElement = hostInput.nativeElement;
  }

  private get value(): string {
    return this.nativeElement.value;
  }

  @HostListener('keyup', ['$event']) onKeyup(event: KeyboardEvent): void {
    let slicedValue = getCleanStringNumber(this.value);
    if (event.key != 'Backspace' && !slicedValue.match(this.ONLY_NUMBERS)) {
      //slice incomming char
      slicedValue = slicedValue.slice(0, -1);
    }

    this.output = this.nativeElement.value = getCurrencyValue(slicedValue);
  }

  updateOutput(inputAmount: string) {
    let slicedValue = getCleanStringNumber(inputAmount);
    this.output = this.nativeElement.value = getCurrencyValue(slicedValue);
  }
}
